import styled from 'styled-components'
import radioUnchecked from '../../asset/radioUnchecked.svg'
import radioChecked from '../../asset/radioChecked.svg'
import theme from '../../styles/theme'

const RadioWrapper = styled.div`
  position: relative;
  display: ${({ isDisplay }) => (isDisplay ? 'flex' : 'none')};
  //padding: 0 0 1rem 0;
  margin: 0 0 1rem 0;
  border-bottom: 1px solid ${theme.color.border};
`

const RadioInput = styled.input`
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  cursor: pointer;
  margin: 0;

  &:checked + label:after {
    background-image: url(${radioChecked});
  }

  &:focus + label:before {
    outline: 3px solid ${theme.color.focus};
    outline-offset: 1px;
  }
`

const RadioLabel = styled.label`
  padding: 0 0.5rem 0 2.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;

  &:before {
    background-image: url(${radioUnchecked});
    border-radius: 50%;
    width: 2.375rem;
    height: 2.375rem;
    content: ' ';
    display: block;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    z-index: 10;
    left: 0;
    top: -1px;
    border: 3px solid transparent;
  }

  &:after {
    background-image: none;
    border-radius: 50%;
    width: 2.375rem;
    height: 2.375rem;
    content: ' ';
    display: block;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    z-index: 11;
    left: 0;
    top: -1px;
    border: 3px solid transparent;
  }
`

const RadioImage = styled.img`
  width: auto;
  height: 38px;
  padding: 0 0.5rem;
  user-select: none;
`

const RadioText = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-right: 1rem;
  display: block;
  user-select: none;
  color: ${theme.color.black};
`

export { RadioWrapper, RadioInput, RadioLabel, RadioImage, RadioText }
